<script setup>
import qq from "@/assets/qq.jpg"
import wenxin from "@/assets/weixin.png"
import bilibili from "@/assets/bilibili.png"

import {ref} from "vue";

const activeNames = ref([])
</script>

<template>
  <div class="info-all">
    <div class="info-desc">
      <h2 style="text-align: center">关于网站</h2>
      <div>
        <el-alert
            title="作者的自我介绍"
            type="info"
            :closable="false"
        >
          <p>本人是一个入行了三年的菜菜的程序员，很喜欢写程序，在程序的海洋中遨游的时候，能将脑海中错综复杂的逻辑网理顺而获得满足感。</p>
          <p>喜欢研究技术，每次学了一个新技术都想着怎么在自己的项目里面用起来，然后发现自己没有足够的资金把这些技术都在服务器上搭建起来（暗示）</p>
          <p>但是本人又很菜，学了很多东西，学的都很浅，一问都会，一面就跪，还容易忘。</p>
          <p>每次看到别的大佬的博客都做的好好看，有时候真的很羡慕，再看看自己的网站，突然感觉好low。也许这就是天赋把，既想不到，也不知道要怎么做，才能画一个好看的页面，可能是没有艺术细胞，<span style="text-decoration: line-through;">毕竟CSS永无止境</span></p>
          <p>唯一的优势是头发还在，<span style="text-decoration: line-through;">不会这就是我很菜的原因吧，在掉了在掉了</span></p>
          <p>不过嘛，虽然菜，还是想去互联网公司，想要去研究高并发，感受服务器时刻在负载的感觉，在家人朋友面前打开一个网页，说这个网页就是我们做的，<span style="text-decoration: line-through;">在线求职</span>。
            想法还是要有的，咱也不想着去大厂，哪怕去小公司累一累呢，没有那么卷的决心，也没有牛逼的天赋，那也要专注好当下，做好自己，比如，做一个自己的博客网站</p>
        </el-alert>
        <h4>项目背景</h4>
        <p>本人喜欢在学习的时候进行整理资料，学习文档总是到处拉取，上传或U盘拷贝，收藏夹也是到处导入导出。于是，出于想要方便自己的目的，决定做一个博客网站，既能在朋友面前装b，还能放到简历上假装自己很牛，<span style="text-decoration: line-through;">虽然毫无技术可言</span>。总之，这个网站就这么诞生了</p>
        <p>代码不难写，买域名买服务器申请备案好麻烦好费钱呀</p>
        <h4>项目技术</h4>
        <p>前端：Vue3,ElementPlus</p>
        <p>后端：SpringBoot,Redis,Mybatis-Plus</p>
      </div>
      <el-divider/>
      <h2 style="text-align: center">联系本人</h2>
      <div class="contact-information">
        <el-row style="text-align: center">
          <el-col :span="8">
            <el-image style="height: 300px" :src="wenxin" fit="fill"/>
          </el-col>
          <el-col :span="8">
            <el-image style="height: 300px" :src="qq" fit="fill"/>
          </el-col>
          <el-col :span="8">
            <el-image style="height: 300px" :src="bilibili" fit="fill"/>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<style scoped lang="less">
.info-all{
  width: 960px;
  margin: 24px auto;
  background: #f3f4f7;
}

.info-desc{
  border-radius: 12px;
  width: 100%;
  min-height: 500px;
  background: #ffffff;
  padding: 2px 24px;
}

.contact-information{
  margin-bottom: 20px;
}
</style>